import * as types from '../types';
import * as oaApi from '../../http/oaApi';

const state = {
    menu_id: '',
    menuAuth: '', // 菜单功能权限列表
    whiteList: [],
    blackList: []
};

const mutations = {
    [types.MENU_ID] (state, status) {
        state.menu_id = status;
    },
    [types.MENU_AUTH] (state, status) {
        state.menuAuth = status;
    },
    add_whiteList (state, name) {
        state.whiteList.push(name);
    },
    add_blackList (state, name) {
        state.blackList.push(name);
    }
};

const getters = {};

const actions = {
    getMenuAuth ({ commit }) {
        oaApi
            .getMenuAuth(
                {
                    menu_id: state.menu_id
                        ? state.menu_id
                        : localStorage.getItem('menu_id')
                },
                'get'
            )
            .then(res => {
                if (res) {
                    commit(types.MENU_AUTH, res.data);
                }
            });
    }
};
export default {
    state,
    actions,
    getters,
    mutations
};
